import './InquiryPages.css';
import { Dribbble, Dumbbell, Mountain, Waves } from 'lucide-react';
import ProgramJourney from '../components/ProgramJourney';
import SEO from '../components/SEO';
import MediaTruthSurface from '../components/MediaTruthSurface';
import { MEDIA_SLOTS } from '../lib/mediaTruth';

const rentals = [
  { icon: Dribbble, title: 'Basketball Court', text: 'Rent our versatile court for games, tournaments, cornhole, pickleball, and other events.' },
  { icon: Dumbbell, title: 'MX4 Studio', text: 'A private indoor training space equipped for team conditioning, cardio, strength, power, and endurance.' },
  { icon: Mountain, title: 'Rockwall', text: 'Create a memorable climbing experience on our two-story indoor Rockwall.' },
  { icon: Waves, title: 'Lap Pool', text: 'Ask our team about reserving indoor pool space for team training or youth activities.' },
];

const RentalsPage = () => (
  <div className="dv-inquiries dv-inquiries--rentals" data-testid="rentals-page">
    <SEO
      title="Facility Rentals at Delta Valley"
      description="Request basketball court, MX4 studio, Rockwall, or indoor pool rentals at Delta Valley Health Club in Brentwood."
      keywords="gym rentals Brentwood, basketball court rental, pool rental, MX4 studio rental"
    />
    <section className="dv-inquiries__hero dv-inquiries__rental-hero">
      <div className="container-custom dv-inquiries__hero-inner">
        <p className="uppercase tracking-[0.25em] text-sm font-semibold text-blue-100 mb-4">Facility Rentals</p>
        <h1 className="dv-size-heading text-4xl md:text-6xl font-bold mb-6">Space for Teams & Events</h1>
        <p className="dv-size-lede text-xl text-blue-100">Bring your practice, tournament, or group experience indoors at Delta Valley.</p>
        <div className="dv-inquiries__actions"><a href="#rental-inquiry" className="dv-inquiries__rental-link">Request rental information ↓</a></div>
        <MediaTruthSurface media={MEDIA_SLOTS.rentalsHero} className="dv-inquiries__media-hold" decorative />
      </div>
    </section>

    <section className="dv-inquiries__section">
      <div className="container-custom dv-inquiries__rental-spaces">
        {rentals.map(({ icon: Icon, title, text }) => (
          <article key={title} id={title.toLowerCase().replaceAll(' ', '-')} className="dv-inquiries__rental-space">
            <div className="dv-inquiries__rental-space-inner">
              <Icon className="text-[#0072BB] mb-4" size={32} />
              <h2 className="dv-size-subheading text-xl font-bold mb-2">{title}</h2>
              <p className="dv-size-body text-gray-600 leading-relaxed mb-4">{text}</p>
            </div>
          </article>
        ))}
      </div>
    </section>

    <ProgramJourney
      id="rental-inquiry" testId="rental-inquiry-journey" photo="A01"
      source="rental-inquiry"
      eyebrow="Facility Rentals"
      title={['Request rental information.', 'Tell us what you need in about a minute.']}
      lede="Tell us what space interests you and our team will follow up with availability."
      interestsQuestion="Which spaces or activities interest you?"
      planTitle="Your rental request" request={['Request', 'Facility rental']}
      reviewNoun="rental request" startLabel="Start My Rental Request" buttonText="Send Rental Request"
      successTitle="Rental Request Received"
      successMessage="Our team will contact you about availability and next steps."
    />
  </div>
);

export default RentalsPage;
